import { t } from 'utilities/TranslationUtils';
import AppLightTooltip from 'components/ui/AppLightTooltip';

interface Props {
  /** Translation key prefix: `<prefix>_q` is the question, `<prefix>_a` the (deliberately cautious) answer. */
  hintKey: string;
}

/** ⓘ next to a chart title; its tooltip answers "how do I read this?" as a question and a hedged answer. */
export default function ChartHint({ hintKey }: Props) {
  return (
    <AppLightTooltip
      title={(
        <span className='pp-chart-hint__tip'>
          <strong>{t(`${hintKey}_q`)}</strong> {t(`${hintKey}_a`)}
        </span>
      )}
    >
      <span className='pp-chart-hint' role='img' aria-label={t(`${hintKey}_q`)} data-test={`pp-chart-hint-${hintKey}`}>ⓘ</span>
    </AppLightTooltip>
  );
}
